import type { DataSourceProvider, DataSourceResult } from "./types"

/**
 * Nominatim (OpenStreetMap) geocoding provider.
 *
 * Usage policy: https://operations.osmfoundation.org/policies/nominatim/
 * - Max 1 request/second (handled by debounce in the UI hook)
 * - Must set a custom User-Agent
 * - Results must credit OpenStreetMap (© OpenStreetMap contributors)
 */
export const nominatimProvider: DataSourceProvider = {
  async fetch(query: string): Promise<DataSourceResult | null> {
    if (!query || query.trim().length < 3) return null

    const params = new URLSearchParams({
      q: query,
      format: "json",
      limit: "1",
      countrycodes: "no",
    })

    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`, {
      headers: {
        "User-Agent": "ESGtrackr/1.0 (https://esgtrackr.no)",
      },
    })

    if (!response.ok) return null

    const results = (await response.json()) as DataSourceResult[]
    if (!results.length) return null

    return results[0]
  },
}
